export default "__VITE_ASSET__DwncKk6K__"